// this function is being used in different parts of the app, so we need to keep it
// it opens the email client
export const openServiceDeskChatOrEmail = () => {
  window.location.href = 'mailto:support@plerion.com';
  return;
};
